/**
 * Digitale pas op de member page.
 *
 * Voyado geeft per klant één persoonlijke link. Die pagina bepaalt zelf of het
 * een Apple- of een Google-pas wordt, en toont op desktop een QR om op de
 * telefoon verder te gaan. Vandaar één knop en geen twee.
 *
 * De link wordt pas bij het klikken opgehaald: hij identificeert de klant, dus
 * hij hoort niet in de HTML te staan van een pagina die gecachet kan worden.
 *
 * Zolang Voyado de card-ID niet heeft geleverd geeft de middleware 501. De knop
 * blijft dan verborgen — een knop die bij aanraking een fout geeft is erger dan
 * geen knop.
 */
(function () {
  var wortel = document.querySelector('[data-loyalty-wallet]');
  if (!wortel) return;

  var endpoint = wortel.getAttribute('data-endpoint');
  var knop = wortel.querySelector('[data-loyalty-wallet-button]');
  if (!knop) return;

  /** Haalt de persoonlijke link op. */
  function haalLink() {
    return fetch(endpoint, { method: 'POST' }).then(function (antwoord) {
      if (!antwoord.ok) throw new Error('HTTP ' + antwoord.status);
      return antwoord.json();
    });
  }

  /**
   * Voyado geeft een object terug met per contact-ID één URL. Welke sleutel dat
   * is weten we hier niet, dus we pakken de eerste string die eruitziet als een
   * adres.
   */
  function pakUrl(data) {
    if (!data || typeof data !== 'object') return null;
    var sleutels = Object.keys(data);
    for (var i = 0; i < sleutels.length; i++) {
      var waarde = data[sleutels[i]];
      if (typeof waarde === 'string' && waarde.indexOf('http') === 0) return waarde;
    }
    return null;
  }

  knop.addEventListener('click', function () {
    knop.disabled = true;
    knop.setAttribute('data-pending', '');

    haalLink()
      .then(function (data) {
        var url = pakUrl(data);
        if (!url) throw new Error('geen pas-URL in het antwoord');
        // Nieuw tabblad: de klant blijft op haar eigen pagina staan, en op
        // desktop is die Voyado-pagina een tussenstap naar de telefoon.
        window.open(url, '_blank', 'noopener');
      })
      .catch(function (fout) {
        console.error('[wallet] pas niet op te halen', fout);
      })
      .then(function () {
        knop.disabled = false;
        knop.removeAttribute('data-pending');
      });
  });

  /*
   * Eén keer vooraf kijken of de pas bestaat. Dat kost een aanroep, maar het
   * alternatief is een knop tonen die pas bij het klikken blijkt te ontbreken —
   * en dat overkomt iedere klant, niet alleen de eerste.
   */
  haalLink()
    .then(function (data) {
      if (pakUrl(data)) {
        // Skelet eruit, knop erin, op dezelfde plek en dezelfde maat.
        wortel.classList.remove('is-laden');
      } else {
        wortel.hidden = true;
      }
    })
    .catch(function () {
      // 501 zolang de card-ID ontbreekt. Stil laten: dit is geen storing maar
      // een onderdeel dat nog niet is opgeleverd.
      wortel.hidden = true;
    });
})();
